import { Component, ChangeDetectorRef  } from '@angular/core';
import { NavController, NavParams, AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseRequestOptions, RequestOptions, Headers, RequestOptionsArgs} from "@angular/http";
import { ImageBrowserUploadProvider } from '../../providers/image-browser-upload/image-browser-upload';

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { VisitorsRegMorePage } from '../visitors-reg-more/visitors-reg-more';
import { LoginPage } from '../login/login';
import { HomePage } from '../home/home';

//@IonicPage()
declare var cordova: any;
@Component({
  selector: 'page-visitoredit',
  templateUrl: 'visitoredit.html',
})
export class VisitoreditPage {

  private vistor_reg : FormGroup;
  lastImage: string = null;
  loading: Loading;

  confirmPass:boolean = false;
  isparking:boolean = false;
  iswifi:boolean = false;
  iswheelChair:boolean = false;
  items:any;

  disclaimer = false;
 

  imgPreview = '../../assets/imgs/upload.jpeg';
  regData = { avatar:'', name: '', surname: '', id_passport: '', email: '',mnumber: '', carreg:'', carmodel:'', carmake:'', company:'' };
  title = "Mr";
  fname = "";
  surname = "";
  id_type = "ID";
  id_passport = "";
  mnumber = "";
  email = "";
  password = "";
  cpassword = "";
  carreg = "";
  carmodel = "";
  carmake = "";
  company = "";
  parkingCheckBox = "";
  submitting = false;

  
  passtype = "password";
  showPass = false;

  datas = "";//[];
  registration = "";
  model = "";
  name = "";
  photoLocation = "";

  accessCode = "";
  authtoken = "";

  queAns = false;
  isloading = true;
  error = false;

  acccode = "";

  
  /** browser upload variable */
  browser = true;
  public image : string = '../../assets/imgs/upload.jpeg';
  public isSelected : boolean 		=	false;
  private _SUFFIX : string;
  public upFileNm : string = '';

  /* nrowser upload var ends **/
  public imgdata : string = '';
  

  validation_messages = {
    'title': [
      { type: 'required', message: '*Please choose title.' },
    ],
    'name': [
      { type: 'required', message: '*Please enter a name.' },
      //{ type: 'pattern', message: '*Please enter characters.' }
    ],
    'surname': [
      { type: 'required', message: '*Please enter a surname.' },
    ],
    'id_passport': [
      { type: 'required', message: '*Please enter an id number.' },
      { type: 'pattern', message: '*Please enter a valid number.' },
    ],
    'email': [
      { type: 'required', message: '*Please enter an email.' },
      { type: 'pattern', message: '*Please enter a valid email.' },
    ],
    'mnumber': [
      //{ type: 'required', message: '*Please enter mobile number.' },
      { type: 'pattern', message: '*Please enter 9 digit mobile number.' }
    ],
      
  }

  constructor( 
      private formBuilder: FormBuilder,  
      public navCtrl: NavController, 
      private toastCtrl: ToastController, 
      public navParams: NavParams,     
      public http: HttpClient,    
      private imagePicker: ImagePicker,    
      private base64: Base64,
      private camera: Camera, 
      private transfer: Transfer, 
      private file: File, 
      private filePath: FilePath, 
      public actionSheetCtrl: ActionSheetController, 
      public platform: Platform, 
      public loadingCtrl: LoadingController ,
      private _ALERT     : AlertController,
      private _IMAGES 		: ImageBrowserUploadProvider,
      private storage: Storage,
      private cdr: ChangeDetectorRef,
      public global: GlobalProvider
    ) {
    
      if (this.platform.is('windows') || this.platform.is('android') || this.platform.is('ios')) {
        this.browser = false;
      }else if (this.platform.is('core') || this.platform.is('mobileweb')) {
        this.browser = true;
      }
      this.acccode = this.navParams.get('accesscode');
      
      //this.getVisitorInfo();
        //this.cdr.detectChanges();
      this.vistor_reg = this.formBuilder.group({
        title: [null],//['', Validators.required],
        name: ["", Validators.required],//, Validators.pattern('[a-zA-Z ]*')],
        surname: ["", Validators.required],
        id_passport: ["",Validators.compose([
                          Validators.required,
                          Validators.pattern('^[0-9]+$')
                        ])
                      ],
        mnumber: ["", Validators.pattern('[0-9]{9}')],
        email: ["",Validators.compose([
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
                  ])],
        carreg: [null],//'',//['', Validators.required],
        carmodel: [null],//'',//['', Validators.required],
        carmake: [null],//'',//['', Validators.required],
        company: [null]//['', Validators.required]
  
      });

      this.storage.get('accesscode').then((val) => {
        console.log('acc = '+val);
        this.accessCode = val;
        this.storage.get('Authorization').then((val1) => {
          console.log('acc = '+this.accessCode);
          this.authtoken = val1;
          this.getVisitorInfo()
        });
        
      });

      //this.getVisitorInfo();
        
    
  }

  //ngAfterViewInit() {
  ngAfterContentChecked(){

  }

  getVisitorInfo(){

    
    
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken//'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzRzhNUU1DayIsInNjb3BlcyI6WyJST0xFX1ZJU0lUT1IiXSwiZXhwIjoxNTQ1NDkyMDEwfQ.v4-JvO9di-g-CuP73ufk8WQYc_5dS13snRXEMD5DlI0ca4BeIf9b6W_iWyU2F7hwyKoKJ_rJODnw1yG7fG75Kg'
      })
    };

    const url = this.global.baseUrl+"api/visitor?verificationCode="+this.acccode;

    

    this.http.get(url, httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            
            this.isloading = false;
            this.error = true;
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                this.storage.clear();
                this.navCtrl.push(LoginPage);
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();

          }else{
            console.log(data.visitorDTO);
            
            this.isloading = false;
            this.error = false;
            //this.datas = data.visitorDTO;
            /*
            this.name = data.visitorDTO.name;
            this.surname = data.visitorDTO.surname;
            this.title = data.visitorDTO.title;
            this.idNumber = data.visitorDTO.idNumber;
            this.email = data.visitorDTO.email;
            this.mnumber = '+27'+data.visitorDTO.phones[0].number;
            this.company = data.visitorDTO.company;
            this.photoLocation = data.visitorDTO.photoLocation;*
            this.mnumber = data.visitorDTO.phones[0].number;
            this.registration = data.visitorDTO.cars[0].registration;
            this.model = data.visitorDTO.cars[0].model;
            this.imgPreview = data.visitorDTO.photoLocation;

            //console.log(this.registration+' mod '+this.model);

            this.storage.set('usermail',data.visitorDTO.email);
            this.queAns = data.visitorDTO.answered;
            console.log(this.queAns);
            */
           
           this.vistor_reg.controls['name'].setValue(data.visitorDTO.name);
           this.vistor_reg.controls['surname'].setValue(data.visitorDTO.surname);
           this.vistor_reg.controls['id_passport'].setValue(data.visitorDTO.idNumber);
           this.vistor_reg.controls['mnumber'].setValue(data.visitorDTO.phones[0].number);
           this.vistor_reg.controls['email'].setValue(data.visitorDTO.email);
           this.vistor_reg.controls['carreg'].setValue(data.visitorDTO.cars[0].registration);
           this.vistor_reg.controls['carmodel'].setValue(data.visitorDTO.cars[0].model);
           this.vistor_reg.controls['carmake'].setValue(data.visitorDTO.cars[0].make);
           this.vistor_reg.controls['company'].setValue(data.visitorDTO.company);

           if(data.visitorDTO.image == ""){
            this.imgPreview = '';//'data:image/jpeg;base64,'+data.visitorDTO.image;
            this.image = '';//'data:image/jpeg;base64,'+data.visitorDTO.image;
            
           }else{
            this.imgPreview = 'data:image/jpeg;base64,'+data.visitorDTO.image;
            this.image = 'data:image/jpeg;base64,'+data.visitorDTO.image;
           }
           //this.imgPreview = data.visitorDTO.photoLocation;
           //this.image = data.visitorDTO.photoLocation;
           this.imgdata = data.visitorDTO.image;

           this.title = data.visitorDTO.title;
           this.id_type = "ID";

              //this.vistor_reg.controls['title'].setValue(data.visitorDTO.title);
            
          }
        }, error => {
        console.log(error);
        
        this.isloading = false;
        this.error = true;
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();

        
    });
  }



  isMatching(group: FormGroup){

    var firstPassword = group.controls['password'].value;
    var secondPassword = group.controls['cpassword'].value;
    if((firstPassword && secondPassword) && (firstPassword != secondPassword)){
      console.log("mismatch");
      return { "pw_mismatch": true };
    } else{
      return null;
    }

  }


  public CValue:String;
  onChange(CValue) {
    const id_passportValue = this.vistor_reg.get('id_passport');
    if(CValue == 'ID'){
      id_passportValue.setValidators([Validators.pattern('^[0-9]+$')]);
    }else if(CValue == 'PASSPORT'){
      id_passportValue.setValidators([Validators.pattern('^[a-zA-Z0-9_.+-]+$')]);
    }
    id_passportValue.updateValueAndValidity();
  }

  showPassword(){
    this.passtype = this.passtype === 'text' ? 'password' : 'text';
    if(this.showPass){
      this.showPass = false;
    }else{
      this.showPass = true;
    }
    
  }
  
  showDisclaimer(){
    this.disclaimer = true;
  }
  hideDisclaimer(){
    this.disclaimer = false;
  }

  formMobileChanged(){
    const emailCtrl = this.vistor_reg.get('email');
    const phoneCtrl = this.vistor_reg.get('mnumber');
    this.vistor_reg.get('mnumber').valueChanges.subscribe(
      (mobileStr: string) => {
        console.log(mobileStr);
        if(mobileStr == ''){
          emailCtrl.setValidators([Validators.required]);
        }else{
          emailCtrl.clearValidators();
        }
        emailCtrl.updateValueAndValidity();
  
    });

  }

  formEmailChanged(){
    const phoneCtrl = this.vistor_reg.get('mnumber');

    this.vistor_reg.get('email').valueChanges.subscribe(
      (emailStr: string) => {
        if(emailStr == ''){
          phoneCtrl.setValidators([Validators.required]);
        }else{
          phoneCtrl.clearValidators();
        }
        phoneCtrl.updateValueAndValidity();
  
    });

  }
  goback(){
    this.navCtrl.pop();
  }
  toggleParking() {
    this.isparking = !this.isparking;

    const parkingRegCtrl = this.vistor_reg.get('carreg');
    const parkingModCtrl = this.vistor_reg.get('carmodel');
    const parkingMakCtrl = this.vistor_reg.get('carmake');
    if(this.isparking){
      parkingRegCtrl.setValidators([Validators.required]);
      parkingModCtrl.setValidators([Validators.required]);
      parkingMakCtrl.setValidators([Validators.required]);
    }else{
      parkingRegCtrl.clearValidators();
      parkingModCtrl.clearValidators();
      parkingMakCtrl.clearValidators();
    }

    parkingRegCtrl.updateValueAndValidity();
    parkingModCtrl.updateValueAndValidity();
    parkingMakCtrl.updateValueAndValidity();
  }

  toggleWifi() {
    this.iswifi = !this.iswifi;
  }
  toggleWheel() {
    this.iswheelChair = !this.iswheelChair;
  }

  /** image upload */
  public presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Select Image Source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public takePicture(sourceType) {
    // Create options for the Camera Dialog
    var options = {
      quality: 20,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,//FILE_URI,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };
   
    // Get the data of an image
    this.camera.getPicture(options).then((imagePath) => {
      // Special handling for Android library
      this.imgPreview = 'data:image/jpeg;base64,' + imagePath;
      this.imgdata = imagePath;
  
      //this.loading.dismissAll()
      this.presentToast('Image succesfully uploaded.');
      /*
      if (this.platform.is('android') && sourceType === this.camera.PictureSourceType.PHOTOLIBRARY) {
        this.filePath.resolveNativePath(imagePath)
          .then(filePath => {
            let correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
            let currentName = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.lastIndexOf('?'));
            this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
          });
      } else {
        var currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
        var correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
        this.copyFileToLocalDir(correctPath, currentName, this.createFileName());
      }*/
    }, (err) => {
      this.presentToast('Error while selecting image.');
    });
  }

  // Create a new name for the image
  private createFileName() {
    var d = new Date(),
    n = d.getTime(),
    newFileName =  n + ".jpg";
    return newFileName;
  }
  
  // Copy the image to a local folder
  private copyFileToLocalDir(namePath, currentName, newFileName) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {
      this.lastImage = newFileName;
      this.uploadImage();
    }, error => {
      this.presentToast('Error while storing file.');
    });
  }
  
  private presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  
  // Always get the accurate path to your apps folder
  public pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

  public uploadImage() {
    // Destination URL
    var url = this.global.uploadUrl+"upload.php";//"http://192.168.1.34/upload/upload.php";
   
    // File for Upload
    var targetPath = this.pathForImage(this.lastImage);
   
    // File name only
    var filename = this.lastImage;
   
    var options = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "multipart/form-data",
      params : {'fileName': filename}
    };
   
    const fileTransfer: TransferObject = this.transfer.create();
   
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
   
    // Use the FileTransfer to upload the image
    fileTransfer.upload(targetPath, url, options).then(data => {
      this.loading.dismissAll()
      this.presentToast('Image succesful uploaded.');
      console.log('image success data');
      console.log(data);
      console.log('path : '+targetPath);
      console.log('file name : '+filename);
      this.imgPreview = this.global.uploadUrl+"uploads/"+filename;
    }, err => {
      this.loading.dismissAll()
      this.presentToast('Error while uploading file.');
      console.log(err);
    });
  }

  /** regiasteration upload */
  regForm(){
    this.submitting = true;

    
    //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=true;
    
    //this.navCtrl.push(VisitorsRegMorePage);

    
    /*let header = new HttpHeaders({
      "Accept":'application/json',
      'Content-Type':'application/json'
    });*/
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };
    //const requestOpt = new RequestOptions({ headers: header });
    var photoLink = ""
    if(this.imgPreview == '../../assets/imgs/upload.jpeg'){
      photoLink = "";
    }else{
      photoLink = this.imgPreview;
    }

    let postData = JSON.stringify({
      
      "updateVisitorDTO": {
        "captureType": "visitor",
        "cars": [
          {
            "make": this.carmake,
            "model": this.carmodel,
            "registration": this.carreg
          }
        ],

        "company": this.company,
        "disclaimer": true,
        "email": this.email,
        "idNumber": this.id_passport,
        "identityType": this.id_type,
        "licenseNumber": this.id_passport,
        "name": this.fname,
        //"parking": this.isparking,
        "passport": this.id_passport,
        "phones": [
          {
            "number": this.mnumber
          }
        ],
        "image":this.imgdata,
        "photoLocation": photoLink,
        "surname": this.surname,
        //"wheelChair": this.iswheelChair,
        //"wifi": this.iswifi,
        "title": this.title,
        "verificationCode":this.acccode
      }
    
    });

    
  
  
    
    
    /*this.vistor_reg.value/*{
      "name": "Customer004",
      "email": "customer004@email.com",
      "mnumber": "0000252525"
    }*/

    this.http.put(this.global.baseUrl+"api/register", postData, httpOptions)
      .subscribe((data:any) => {
        console.log(data['_body']);
        console.log(data);
        console.log(data.error);
          if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 20000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            this.disclaimer = false;
            
          }else{
            let toast = this.toastCtrl.create({
              message: 'Visitor updated successfully!.',
              duration: 3000,
              position: 'bottom',
              showCloseButton:false,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            //(<HTMLInputElement> document.getElementById('submitBtn')).disabled=false;
            this.navCtrl.push(HomePage);
            this.disclaimer = false;
            this.submitting = false;
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        this.disclaimer = false;
        this.submitting = false;
    });
  }

  /** photo capture  */
  getPhoto() {
    let options = {
      maximumImagesCount: 1
    };
    this.imagePicker.getPictures(options).then((results) => {
      for (var i = 0; i < results.length; i++) {
          this.imgPreview = results[i];
          this.base64.encodeFile(results[i]).then((base64File: string) => {
            this.regData.avatar = base64File;
            //this.imgPreview = base64File;
            console.log(base64File);
            const httpOpt = {
              headers: new HttpHeaders({
                'Content-Type':  '*/*',//'multipart/form-data',
                'Accept': '*/*'
              })
            };
            let imgData = JSON.stringify({
              "file": this.imgPreview//base64File
            });
            this.http.post(this.global.baseUrl+"api/photo/upload", imgData, httpOpt)//requestOpt)
              .subscribe(data => {
                console.log(data['_body']);
                }, error => {
                console.log(error);
            });
          }, (err) => {
            console.log(err);
          });
      }
    }, (err) => { });
  }

  
  /** browser upload */

  /**
    * @public
    * @method selectFileToUpload
    * @param event  {any}     	The DOM event that we are capturing from the File input field
    * @description    			Handles the selection of image files from the user's computer,
    *                 			validates they are of the correct file type and displays the
    *							selected image in the component template along with an upload
    * 							button
    * @return {none}
    */
   selectFileToUpload(event) : void
   {
    this.loading = this.loadingCtrl.create({
      content: 'Uploading...',
    });
    this.loading.present();
      this._IMAGES
      .handleImageSelection(event)
      .subscribe((res) =>
      {

         // Retrieve the file type from the base64 data URI string
         this._SUFFIX 			= res.split(':')[1].split('/')[1].split(";")[0];


         // Do we have correct file type?
         if(this._IMAGES.isCorrectFileType(this._SUFFIX))
         {

            // Hide the file input field, display the image in the component template
            // and display an upload button
            this.isSelected 	= true
            this.image 			= res;
            this.imgPreview = res;
            var splitted = res.split(",").pop(); 
            this.imgdata = splitted;
            
            this.loading.dismissAll()
            this.presentToast('Image succesfully uploaded.');
            /*
            this.upFileNm = 'brw_'+Date.now();
            this.uploadFile();*/
         }

         // If we don't alert the user
         else
         {
            this.displayAlert('You need to select an image file with one of the following types: jpg, gif or png');
            this.loading.dismissAll()
         }
      },
      (error) =>
      {
         console.dir(error);
         //this.displayAlert(error.message);
         
         this.loading.dismissAll()
         this.presentToast('Error while uploading file.');
      });
   }




   /**
    * @public
    * @method uploadFile
    * @description    			Handles uploading the selected image to the remote PHP script
    * @return {none}
    */
   uploadFile() : void
   {
      this._IMAGES
      .uploadImageSelection(this.image,
                            this._SUFFIX,
                            this.upFileNm)
      .subscribe((res) =>
      {
         //this.displayAlert(res.message);
         console.log(res.path);
         this.imgPreview = res.path;
         
         this.loading.dismissAll()
         this.presentToast('Image succesfully uploaded.');
         /*
          const httpOpt = {
            headers: new HttpHeaders({
              'Content-Type':  '/*',
              'Accept': '/*'
            })
          };
          let imgData = JSON.stringify({
            "file": res.path//base64File
          });
          this.http.post(this.global.baseUrl+"api/photo/upload", imgData, httpOpt)//requestOpt)
          .subscribe(data => {
              console.log(data['_body']);
              this.loading.dismissAll()
              this.presentToast('Image succesful uploaded.');
          }, error => {
              console.log(error);
              this.loading.dismissAll()
              this.presentToast('Error while uploading file.');
              console.log(error);
          });*/
      },
      (error : any) =>
      {
         console.dir(error);
         this.displayAlert(error.message);
         this.loading.dismissAll()
      });
   }




   /**
    * @public
    * @method displayAlert
    * @param message  {string}  The message to be displayed to the user
    * @description    			Use the Ionic AlertController API to provide user feedback
    * @return {none}
    */
   displayAlert(message : string) : void
   {
      let alert : any   = this._ALERT.create({
         title 		: 'Heads up!',
         subTitle 	: message,
         buttons 	: ['Got it']
      });
      alert.present();
   }


}



// WEBPACK FOOTER //
// ./src/pages/visitoredit/visitoredit.ts